export const indicatorUnplannedExecuted = (chartData) => {
  const totalDelegated = Number(chartData?.total_delegated) || 0;
  const totalExec = Number(chartData?.total_delegated_executed) || 0;
  const totalNotExec =
    Number(chartData?.total_delegated_not_executed) ||
    Math.max(totalDelegated - totalExec, 0);

  let pctExec = chartData?.delegated_executed_pct
    ? chartData?.delegated_executed_pct
    : 0;
  if (!Number.isFinite(pctExec)) pctExec = 0;

  const categoriasExec = chartData?.categories_delegated_executed || {
    A: 0,
    B: 0,
    C: 0,
    D: 0
  };

  const categoriasNoExec = chartData?.categories_delegated_not_executed || {
    A: 0,
    B: 0,
    C: 0,
    D: 0
  };

  return {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      events: {
        render() {
          const chart = this;
          const series = chart.series && chart.series[0];
          if (!series || !series.center) return;

          if (chart.centerTitle) {
            chart.centerTitle.destroy();
            chart.centerTitle = null;
          }
          if (chart.centerValue) {
            chart.centerValue.destroy();
            chart.centerValue = null;
          }

          const centerX = series.center[0] + 40 + chart.plotLeft;
          const centerY = series.center[1] + chart.plotTop;

          // 🔹 línea 1: "Cumplimiento"
          chart.centerTitle = chart.renderer
            .text("Cumplimiento", centerX, centerY)
            .css({
              color: "#000",
              fontSize: "14px",
              fontWeight: "400",
              textAlign: "center",
              textOutline: "none",
              pointerEvents: "none"
            })
            .attr({ align: "center" })
            .add();

          const titleBox = chart.centerTitle.getBBox();
          chart.centerTitle.attr({
            x: centerX - titleBox.width / 2,
            y: centerY - 6
          });

          // 🔹 línea 2: "72 %"
          const valueText = `${pctExec.toFixed(0)} %`;
          chart.centerValue = chart.renderer
            .text(valueText, centerX, centerY)
            .css({
              color: "#000",
              fontSize: "22px",
              fontWeight: "600",
              textAlign: "center",
              textOutline: "none",
              pointerEvents: "none"
            })
            .attr({ align: "center" })
            .add();

          const valueBox = chart.centerValue.getBBox();
          chart.centerValue.attr({
            x: centerX - valueBox.width / 2,
            y: centerY + 16
          });
        }
      }
    },

    title: { text: "" },
    subtitle: { text: "" },

    legend: {
      enabled: true,
      align: "center",
      verticalAlign: "bottom"
    },

    tooltip: {
      useHTML: true,
      style: { zIndex: 9999 },
      formatter: function () {
        const p = this.point;

        if (!totalDelegated) {
          return `
            <div style="min-width:220px;">
              <div style="font-weight:700; margin-bottom:6px;">
                Sin actividades delegadas en el período seleccionado.
              </div>
            </div>
          `;
        }

        if (p.name === "Actividades Delegadas Ejecutadas") {
          return `
            <div style="min-width:220px;">
              <div style="font-weight:700; color:#4b3fd1; margin-bottom:6px;">
                Actividades Delegadas Ejecutadas
              </div>

              <div style="display:flex; justify-content:space-between; margin-bottom:8px;">
                <span><strong>TOTAL</strong></span>
                <span><strong>${pctExec.toFixed(
                  0
                )}%</strong> (${totalExec}/${totalDelegated})</span>
              </div>

              <div>Clasificación A: <strong>${categoriasExec.A || 0}</strong></div>
              <div>Clasificación B: <strong>${categoriasExec.B || 0}</strong></div>
              <div>Clasificación C: <strong>${categoriasExec.C || 0}</strong></div>
              <div>Clasificación D: <strong>${categoriasExec.D || 0}</strong></div>
            </div>
          `;
        }
        const pctNoExec =
          totalDelegated > 0 ? (100 * totalNotExec) / totalDelegated : 0;

        return `
          <div style="min-width:220px;">
            <div style="font-weight:700; color:#42b7ff; margin-bottom:6px;">
              Actividades Delegadas NO Ejecutadas
            </div>

            <div style="display:flex; justify-content:space-between; margin-bottom:8px;">
              <span><strong>TOTAL</strong></span>
              <span><strong>${pctNoExec.toFixed(
                0
              )}%</strong> (${totalNotExec}/${totalDelegated})</span>
            </div>

            <div>Categoría A: <strong>${categoriasNoExec.A || 0}</strong></div>
            <div>Categoría B: <strong>${categoriasNoExec.B || 0}</strong></div>
            <div>Categoría C: <strong>${categoriasNoExec.C || 0}</strong></div>
            <div>Categoría D: <strong>${categoriasNoExec.D || 0}</strong></div>
          </div>
        `;
      }
    },

    plotOptions: {
      pie: {
        innerSize: "75%",
        borderWidth: 0,
        dataLabels: {
          enabled: true,
          distance: -30,
          formatter() {
            return `${this.point.percentage.toFixed(0)}%`;
          },
          style: {
            fontSize: "11px",
            fontWeight: "600",
            textOutline: "none"
          }
        }
      }
    },

    series: [
      {
        name: "Actividades",
        innerSize: "75%",
        colorByPoint: true,
        data: [
          {
            name: "Actividades Delegadas Ejecutadas",
            y: totalExec,
            color: "#5b4fff"
          },
          {
            name: "Actividades Delegadas No Ejecutadas",
            y: totalNotExec,
            color: "#42b7ff"
          }
        ]
      }
    ],

    credits: { enabled: false }
  };
};
